<template>
  <div>
    <div class="loading" v-if="social_status">
      <i class="fa fa-spinner fa-pulse" style="font-size: 6rem;"></i>
    </div>
    <div class="register_opt" v-else>
      <div id="Login">
        <div class="login_box">
          <Title title_name="Login"></Title>
          <div class="login_box_content">
            <div class="content">
              <p class="content_p">歡迎使用FB、Google、LINE帳號快速登入，設定完成後即可直接使用FB、Google、Line帳號登入！</p>
              <div class="content_img">
                <img src="@/assets/social_icon/facebook_login.jpg" v-if="this.social_info.type == 'facebook'" alt />
                <img src="@/assets/social_icon/line_login.jpg" v-if="this.social_info.type == 'line'" alt />
                <img src="@/assets/social_icon/google_login.jpg" v-if="this.social_info.type == 'google'" alt />
              </div>
              <div class="connect">
                <span>{{social_info.type}} 連結帳號 : &nbsp;{{social_info.name}}</span>
              </div>
              <div class="connect_input">
                <form>
                  <div>
                    <input type="radio" name="member_conn" value="1" v-model="radio">我已經是上聯會員(登入即完成設定)
                    <div class="input_box">
                      <InputBox v-for="(item, index) in input_info.slice(13, 15)" :key="item.input_id" :input_info="input_info.slice(13, 15)[index]" @input_content="input_content"></InputBox>
                    </div>
                  </div>
                  <div>
                    <input type="radio" name="member_conn" value="2" v-model="radio">我要註冊成為上聯會員
                  </div>
                </form>
              </div>
              <div class="submit">
                <div class="btn">
                  <MoreButton button_text="確認送出" @click.native="social_submit()" button_href="javascript:void(0);"></MoreButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/base/Title'
import MoreButton from '@/components/base/MoreButton'
import InputBox from "@/components/base/InputBox";
export default {
  name: "social_link",
  components: {
    'MoreButton': MoreButton,
    'Title': Title,
    'InputBox': InputBox,
  },
  data() {
    return {
      input_info: require("@/plugins/input_info"), //input資料
      social_info: {
        type: "", // ex: facebook, line, google
        social_user_id: "",
        name: ""
      },
      social_member: {},
      social_status: false, // 綁定狀態(綁定、未綁定)
      radio: "1",
      token: "",
    };
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/"
    }
  },
  created() {
    var vm = this;
    vm.social_info.type = vm.queryString("type") || vm.$cookies.get('social_info').type
    vm.social_info.social_user_id = vm.queryString("social_user_id")
    vm.social_info.name = vm.queryString("social_name")

    // 將 social_info 存入 cookie 中
    vm.$cookies.set("social_info", JSON.stringify(vm.social_info))

    // 第三方登入檢查，檢查是否有註冊過
    var social_api = vm.API + "api/auth/login/social"
    var data = new FormData()
    data.set("type", vm.social_info.type)
    data.set("social_user_id", vm.social_info.social_user_id)
    vm.social_status = true
    vm.axios.post(social_api, data).then(res => {
        // console.log(res)
        if (res.data.status == 200) {
          // cookie 時效為半天
          // vm.social_status = true
          vm.$cookies.config(60 * 60 * 12, "")
          vm.$cookies.set("member", JSON.stringify(res.data.data))
          vm.$cookies.remove("social_info")
          vm.$router.push("/member/profile")
        } else if (res.data.status == 711) {
          vm.$router.push({ name: "email_auth", params: { email: vm.email } })
        } else if (res.data.status == 721) {
          // 尚未綁定
          vm.social_status = false
        } else {
          // alert("錯誤碼: " + res.data.status + " " + res.data.message)
        }
      })
      .catch(function(error) {
        console.log(error)
      })
  },
  methods: {
    // 擷取 queryString 訊息
    queryString(text) {
      var str = decodeURIComponent(window.location.search.substring(1))
      var arr = str.split("&")
      for (var i = 0; i < arr.length; i++) {
        var v = arr[i].split("=")
        if (v[0] == text) return v[1].replace("+", " ")
      }
      return ""
    },
    input_content(v) {
      this.social_member[v[1]] = v[0]
    },
    // 第三方綁定，已是上聯會員
    social_submit() {
      var vm = this
      if(vm.radio == "1"){
        // 送出綁定
        var token_api = vm.API + "api/auth/login/web"
        var social_url = vm.API + "api/member/social/" + vm.social_info.type
        var data = new FormData()
        for (var i in vm.social_member){
          data.set(i, vm.social_member[i])
        }
        vm.axios.post(token_api, data).then(res => {
          if (res.data.status == 200){
            data.set("token", res.data.data.token)
            data.set("social_user_id", vm.social_info.social_user_id)
            vm.axios.post(social_url, data).then(res => {
              console.log(res)
              if(res.data.status == 200){
                alert('綁定成功')
                vm.$cookies.remove('social_info')
                vm.$router.push("/member/profile")
              }
            })
            .catch(function(error) {
              console.log(error)
            })
          }
        })
        .catch(function(error){
          console.log(error)
        })
        // alert(social_url)
      } else {
        // 轉至註冊頁
        vm.$router.push({name: 'social_register', params: {social_info: vm.social_info}})
      }
    }
  }
}
</script>
<style>
.loading {
  text-align: center;
  margin-top: 30px;
}
#Login {
  margin: 0 auto;
  padding: 10px;
}
.login_box {
  width: 500px;
  max-width: 100%;
  margin: 15px auto 0;
  border-radius: 20px;
  border: 3px solid #37c5f3;
  overflow: hidden;
}
.login_box .title {
  text-align: center;
  background: #37c5f3;
  height: 52px;
  font-size: 2rem;
  font-weight: bold;
}
.connect{
  margin: 15px 0;
}
.content{
  padding: 0 10px;
  letter-spacing: 2px;
}
.content_p{
  color: #848484;
  text-align: center;
}
.content_img{text-align: center}
.content_img>img{
  max-width: 100px;
}
.connect_input>form>div{
  margin: 10px 0;
}
.input_box{
  padding: 0 20px;
}
.inputbox_container label{
  font-size: 1rem;
}
@media (max-width: 400px) {
  .content{
    font-size: 0.9rem;
  }
}
</style>